module.exports = __webpack_public_path__ + "img/police_car.fccf6c03.jpg";